import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  modalData: null | {
    title: string;
    body: React.ReactNode;
    cancelFunction?: () => void;

  },
  alertData: null | {
    title: string;
    body: React.ReactNode;
    cancelFunction?: () => void;
  }
};

const initialState: ModalState = {
  modalData: null,
  alertData: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setModalData: (state, action: PayloadAction<ModalState["modalData"]>) => {
      state.modalData = action.payload;
    },
    setAlertData: (state, action: PayloadAction<ModalState["alertData"]>) => {
      state.alertData = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add extra reducers here
  },
});

export const { setAlertData, setModalData} = modalSlice.actions;
export const selectModalData = (state: { modal: ModalState }) => state.modal.modalData;
export const selectAlertData = (state: { modal: ModalState }) => state.modal.alertData;
export default modalSlice.reducer;